'use client';

import React, { useState } from 'react';

import { Article, SNIPPET_TYPE } from '@repo/types';

import { PureArticleSnippetsTabs } from '@/app/(app)/articles/_components/article-snippets-tabs';
import { PureKeySources } from '@/app/(app)/articles/_components/key-sources';
import { PureKeyTakeaways } from '@/app/(app)/articles/_components/key-takeaways';
import { PureMainCharts } from '@/app/(app)/articles/_components/main-charts';

interface ArticleAnalysisContentProps {
  articleMetrics: Article;
}

export const ArticleAnalysisContent: React.FC<ArticleAnalysisContentProps> = ({
  articleMetrics,
}) => {
  const [currTab, setCurrTab] = useState<SNIPPET_TYPE>(
    SNIPPET_TYPE.CLAIMEDFACTS,
  );

  return (
    <div className="flex flex-1 flex-col items-center justify-center space-y-1.5">
      <div className="flex flex-1 flex-col space-y-reverse @cred-md:space-y-reverse @cred-lg:space-y-reverse @cred-xl:space-y-reverse space-y-3 ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 @cred-md:space-y-3.5 @cred-lg:space-y-4 @cred-xl:space-y-5">
        <div className="space-y-2 @cred-md:space-y-2.5 @cred-xl:space-y-3.5 mt-0!">
          <div className="flex w-full px-3 @cred-md:px-3.5 @cred-lg:px-4 @cred-xl:px-5">
            <span className="font-bold leading-4.75 @cred-md:text-lg @cred-md:leading-5.25 @cred-lg:text-xl @cred-lg:leading-5.75 @cred-xl:text-2xl @cred-xl:leading-7">
              Key Takeaways
            </span>
          </div>
          <div className="px-3 @cred-md:px-3.5 @cred-lg:px-4 @cred-xl:px-5">
            <PureKeyTakeaways articleMetrics={articleMetrics} />
          </div>
        </div>

        <div className="px-3 @cred-md:px-3.5 @cred-lg:px-4 @cred-xl:px-5">
          <PureMainCharts
            articleMetrics={articleMetrics}
            currTab={currTab}
            setCurrTab={setCurrTab}
          />
        </div>

        <div className="mt-1! @cred-md:mt-1.5! @cred-lg:mt-2! @cred-xl:mt-2.5!">
          <PureArticleSnippetsTabs
            articleMetrics={articleMetrics}
            currTab={currTab}
            setCurrTab={setCurrTab}
          />
        </div>

        <div className="mt-auto! space-y-2 @cred-md:space-y-2.5 @cred-xl:space-y-3.5">
          <div className="flex w-full px-3 pt-3 @cred-md:px-3.5 @cred-md:pt-3.5 @cred-lg:px-4 @cred-xl:px-5 @cred-xl:pt-5">
            <span className="text-sm font-bold leading-4 @cred-md:text-base @cred-md:leading-4.75 @cred-xl:text-xl @cred-xl:leading-5.75">
              Key Sources
            </span>
          </div>
          <div className="px-3 @cred-md:px-3.5 @cred-lg:px-4 @cred-xl:px-5">
            <PureKeySources articleMetrics={articleMetrics} />
          </div>
        </div>
      </div>
    </div>
  );
};
